'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import Radio from '@nib-components/radio';
import { Box } from '@nib/layout';
const validFormModes = ['light', 'white'];
export const isObjectOption = option => {
  return Boolean(option.label);
};
export default function RadioGroup(props) {
  const {
    name,
    id,
    options,
    value,
    disabled,
    component: Component = Radio,
    boldLabel,
    ...otherProps
  } = props;
  const hasSubtitle = Object.values(options).some(option => option === null || option === void 0 ? void 0 : option.subtitle);
  const optionsArray = Array.isArray(options) ? options : Object.keys(options).map(key => {
    if (isObjectOption(options[key])) {
      return {
        value: key,
        ...options[key]
      };
    }
    return {
      value: key,
      label: options[key]
    };
  });
  return /*#__PURE__*/_jsx(Box, {
    display: "flex",
    flexDirection: {
      xs: 'column',
      sm: props.inline ? 'row' : 'column'
    },
    flexWrap: "wrap",
    gap: props.isCompact ? 3 : 4,
    "data-mesh-component": "RADIO-GROUP",
    children: optionsArray.map(option => {
      if (isObjectOption(option)) {
        const objectOption = option;
        return /*#__PURE__*/_createElement(Component, {
          ...otherProps,
          key: objectOption.value,
          name: name,
          id: `${id}-${objectOption.value}`,
          value: objectOption.value,
          selected: objectOption.value === value,
          disabled: disabled || objectOption.disabled,
          label: objectOption.label,
          subtitle: objectOption.subtitle,
          boldLabel: boldLabel || hasSubtitle
        });
      }
      return /*#__PURE__*/_createElement(Component, {
        ...otherProps,
        key: option.value,
        name: name,
        id: `${id}-${option.value}`,
        value: option.value,
        selected: option.value === value,
        disabled: disabled,
        label: option.label,
        boldLabel: boldLabel || hasSubtitle
      });
    })
  });
}
RadioGroup.displayName = 'RadioGroup';